import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h3>Sorry! Page Not Found!</h3>
        </div>
    );
};

export default NoMatch;